import { Link } from "react-router-dom";
import StadaLogo from "../../assets/icons/stada_logo.svg";

const Header = () => {
  return (
    <div className="header-wrapper">
      <Link to={"/"} className="header-wrapper-link">
        <img src={StadaLogo} height={50} alt="stada logo" />
      </Link>
    </div>
  );
};

export default Header;
